import { ASSETS_PATHS } from 'constants/paths';
import { CASH_FIELD_NAMES } from 'pages/AffordaAssets/AffordaAssets.Details.Cash.constants';
import { CERTIFICATES_FIELD_NAMES } from 'pages/AffordaAssets/AffordaAssets.Details.Certificates.constants';
import { CHECKING_FIELD_NAMES } from 'pages/AffordaAssets/AffordaAssets.Details.Checkings.constants';
import { FEDERAL_TAX_REFUND_CREDIT_FIELD_NAMES } from 'pages/AffordaAssets/AffordaAssets.Details.FederalTaxRefundCredit.constants';
import { LIFE_INSURANCE_FIELD_NAMES } from 'pages/AffordaAssets/AffordaAssets.Details.LifeInsurances.constants';
import { OTHER_FIELD_NAMES } from 'pages/AffordaAssets/AffordaAssets.Details.Others.constants';
import { PAYCARD_FIELD_NAMES } from 'pages/AffordaAssets/AffordaAssets.Details.Paycards.constants';
import { PROPERTY_FIELD_NAMES } from 'pages/AffordaAssets/AffordaAssets.Details.Properties.constants';
import { REAL_ESTATE_FIELD_NAMES } from 'pages/AffordaAssets/AffordaAssets.Details.RealEstate.constants';
import { RETIREMENT_FIELD_NAMES } from 'pages/AffordaAssets/AffordaAssets.Details.Retirements.constants';
import { SOLD_ASSETS_FIELD_NAMES } from 'pages/AffordaAssets/AffordaAssets.Details.SoldAssets.constants';
import { STOCK_FIELD_NAMES } from 'pages/AffordaAssets/AffordaAssets.Details.Stocks.constants';
import { TREASURY_FIELD_NAMES } from 'pages/AffordaAssets/AffordaAssets.Details.Treasuries.constants';
import { TRUST_FIELD_NAMES } from 'pages/AffordaAssets/AffordaAssets.Details.Trusts.constants';
import { CHECKINGS_ACCOUNT_TYPE } from './accountTypes.constants';

export const PATHS = ASSETS_PATHS;

export const PAY_FREQUENCY_HOURLY = 'hourly';
export const PAY_FREQUENCY_BI_WEEKLY = 'biweekly';
export const PAY_FREQUENCY_MONTHLY = 'monthly';
export const PAY_FREQUENCY_WEEKLY = 'weekly';
export const PAY_FREQUENCY_SEMI_MONTHLY = 'semimonthly';
export const PAY_FREQUENCY_ANNUALLY = 'annually';

export const COMMON_PAY_FREQUENCY_OPTIONS = {
  WEEKLY: {
    value: PAY_FREQUENCY_WEEKLY,
    text: 'afforda.wagesAndIncome.details.job.weekly',
  },
  MONTHLY: {
    value: PAY_FREQUENCY_MONTHLY,
    text: 'afforda.wagesAndIncome.details.job.monthly',
  },
  ANNUALLY: {
    value: PAY_FREQUENCY_ANNUALLY,
    text: 'afforda.wagesAndIncome.details.job.annually',
  },
};

export const ASSETS_SECTION_NAMES = {
  CASH: 'cash',
  CHECKINGS: 'checkings',
  CHOICES: 'choices',
  PAYCARDS: 'paycards',
  CERTIFICATES: 'certificates',
  FEDERAL_TAX_REFUND_CREDIT: 'federalTaxes',
  TRUSTS: 'trusts',
  TREASURIES: 'treasuries',
  STOCKS: 'stocks',
  RETIREMENTS: 'retirements',
  LIFE_INSURANCES: 'lifeInsurances',
  SOLD_ASSETS: 'soldAssets',
  PROPERTIES: 'properties',
  REAL_ESTATE: 'realEstate',
  VEHICLES: 'vehicles',
  OTHER_ASSETS: 'others',
  GIFTS: 'gifts',
  UNEMPLOYMENTS: 'unemployments',
  PENSIONS: 'pensions',
  ONLINES: 'onlines',
  OVERVIEW: 'overview',
  SUMMARY: 'summary',
};

// Only adding optional forms steps fields here. Can change this later if needed.
export const ASSETS_PATHS_TO_FIELD_NAMES_MAP = {
  [ASSETS_PATHS.CASH]: CASH_FIELD_NAMES,
  [ASSETS_PATHS.CHECKINGS]: CHECKING_FIELD_NAMES,
  [ASSETS_PATHS.CERTIFICATES]: CERTIFICATES_FIELD_NAMES,
  [ASSETS_PATHS.PAYCARD]: PAYCARD_FIELD_NAMES,
  [ASSETS_PATHS.FEDERAL_TAX_REFUND_CREDIT]:
    FEDERAL_TAX_REFUND_CREDIT_FIELD_NAMES,
  [ASSETS_PATHS.TRUST]: TRUST_FIELD_NAMES,
  [ASSETS_PATHS.TREASURY_BILLS]: TREASURY_FIELD_NAMES,
  [ASSETS_PATHS.STOCKS]: STOCK_FIELD_NAMES,
  [ASSETS_PATHS.RETIREMENT]: RETIREMENT_FIELD_NAMES,
  [ASSETS_PATHS.LIFE_INSURANCE]: LIFE_INSURANCE_FIELD_NAMES,
  [ASSETS_PATHS.SOLD_ASSET]: SOLD_ASSETS_FIELD_NAMES,
  [ASSETS_PATHS.PROPERTY]: PROPERTY_FIELD_NAMES,
  [ASSETS_PATHS.REAL_ESTATE]: REAL_ESTATE_FIELD_NAMES,
  [ASSETS_PATHS.OTHER_ASSETS]: OTHER_FIELD_NAMES,
};

export const NEW_ASSET = {
  memberId: '',
  amount: '',
  feesToConvertCash: '',
  interestRate: '',
  type: '',
};

// Special Fields for Checkings
export const NEW_CHECKINGS = {
  ...NEW_ASSET,
  type: CHECKINGS_ACCOUNT_TYPE,
  dateOpened: '',
  averageBalance: '',
};

// Special Fields for Real State
export const NEW_REAL_ESTATE = {
  ...NEW_ASSET,
  address: '',
  city: '',
  state: '',
  zip: '',
  planning: '',
  liveIn: '',
  assetType: '',
  marketValue: '',
  mortgageBalance: '',
  rentReceived: '',
  costToSell: '',
  interestPortion: '',
  taxes: '',
};

export const NEW_SOLD_ASSET = {
  ...NEW_ASSET,
  assetType: [],
  otherAssetType: '',
  dateSold: '',
  marketValue: '',
  salePrice: '',
};

export const NEW_TRUST = {
  ...NEW_ASSET,
  interestRate: '',
  withdrawal: '',
};
